window.addEventListener('load', () => {
  const elements = document.querySelectorAll('[data-autosubmit]')
  elements.forEach((element) => {
    element.addEventListener('change', () => {
      const form = document.getElementById(element.getAttribute('data-autosubmit'))
      form.submit()
    })
  })
})
